import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { TeslaAutocompleteComponent } from '@tesla/angular2-tesla-common/autocomplete/autocomplete.component';
import { AppSettings } from 'src/app/app.settings';
import { BaseGridPage } from 'src/app/core/basepages/allbasepages';
import { PartSystemDTO } from 'src/app/models/external/partsystem-dto';
import { SourceType } from 'src/app/models/sourcetype';
import { DataService } from 'src/app/services/data.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NGXLogger } from 'ngx-logger';
import { LocalstorageService } from 'src/app/services/localstorage.service';
import { SpinnerService } from 'src/app/services/spinner.service';
import { ToastService } from 'src/app/services/toaster/toaster.service';
import { FormService } from 'src/app/services/form';
import { of } from 'rxjs';
import { Constants } from 'src/app/core/constants';
import { QueryAssignmentsForPEDTO } from 'src/app/models/internal/query-assignments-for-pe-dto';
import { SearchFilter } from 'src/app/models/internal/searchfilter';
import { MatDialog } from '@angular/material/dialog';
import { ReassignPeComponent } from '../reassign-pe/reassign-pe.component';
import { DeletePackageEngineerAssignmentDTO } from 'src/app/models/deletePackageEngineerAssignmentDTO';
import Helper from 'src/app/core/utility/helper';
import { Router } from '@angular/router';
import { SioCode } from 'src/app/models/siocode';
import { TslMultiSelectSettings } from '@tesla/ng-tds';
import { ReassignPackageEngineerDTO } from '../../../models/reassign-packageengineerDTO';

@Component({
  selector: 'app-assigned-pe',
  templateUrl: './assigned-pe.component.html',
  styleUrls: ['./assigned-pe.component.scss']
})
export class AssignedPeComponent extends BaseGridPage implements OnInit, AfterViewInit {

  appSettings: AppSettings;
    pe_assignmentSearchForm: FormGroup;
    peList: number[];
    peAssignmentsList: any[];
    sourceTypeList: SourceType[];
    partSystemList: PartSystemDTO[];
    availablePartSystemList: PartSystemDTO[];
    sioCodeList: SioCode[];
  filteredsioCodeList: SioCode[];
  allItemsCheckBoxSelected: boolean = false;
    sourceTypeId: number;
    partSystemId: number;
    searchSupplierURL: string;

    supplierAssginmentMessage: string = '';
    SIOCodeAssginmentMessage: string = '';
    @ViewChild('PEAutoComplete') PEAutoComplete: TeslaAutocompleteComponent;
    @ViewChild('SupplierAutoComplete') SupplierAutoComplete: TeslaAutocompleteComponent;
    autoCompletePEURL: string;
    public formErrors = {
        PEId: '',
        SourceTypeId: '',
        PartCategoryId: '',
        SupplierCode: '',
      SioCodeId: '',
      PartNumber: ''
    };

    searchClicked = false;
  isDeleteButtonClicked: boolean = false;
  checkboxSelected = [];
  deletePackageEngineerAssignmentDTO: DeletePackageEngineerAssignmentDTO = new DeletePackageEngineerAssignmentDTO();
  reassignPackageEngineerDTO: ReassignPackageEngineerDTO = new ReassignPackageEngineerDTO();
  SioCodeSettings: TslMultiSelectSettings = {
    enableSearchFilter: true,
    noDataLabel: 'Search For Siocode',
    labelKey: 'Description',
    primaryKey: 'Id'
  }

  constructor(
    private dataService: DataService,
        private fb: FormBuilder,
        private toastService: ToastService,
        public FormService: FormService,
        localstorageService: LocalstorageService,
        private spinnerService: SpinnerService,
        logger: NGXLogger,
        appSettings: AppSettings,
        private router: Router,
    private matDialog: MatDialog
  ) {
    super(localstorageService, logger, appSettings);
        this.pe_assignmentSearchForm = this.fb.group({
            PEId: [null],
            SourceTypeId: [null],
            PartCategoryId: [null],
            SupplierCode: [null],
          SioCodeId: [null],
          PartNumber: [null]
        });
        this.appSettings = appSettings;
        this.autoCompletePEURL = this.appSettings.Packaging2APIUrl + '/peassignment/pe/all';
        this.searchSupplierURL = this.appSettings.Packaging2APIUrl + '/externaldata/supplier/all';

   }

  ngOnInit() {
    this.initFilterValues();
    this.pe_assignmentSearchForm.controls['PEId'].patchValue(0);
    this.searchClicked = true;
    this.getAllCurrentAssignments();
  }

  initFilterValues(): void {
    this.filter = new SearchFilter();
}

fillGrid(): void {
  this.filter.Skip = this.skip;
  this.filter.Take = this.pageSize;
  this.allItemsCheckBoxSelected = false;
  this.UpdateFilter();
  this.getAllCurrentAssignments();
}

getAllPEs() {
  this.dataService
      .getPEs()
      .subscribe((response: any) => {
          // this.partInfo = response
          if (response != null) {
              this.peList = response.Data;
          }
      });
}

UpdateFilter() {
  if (this.PEAutoComplete.list.length === 0 && this.getPEId() == null) {
      this.pe_assignmentSearchForm.controls['PEId'].patchValue(-1);
  }
  if((this.getSourceTypeId() != null || this.getPartCategoryId() != null || this.getSupplierCode() != null) && this.PEAutoComplete.list.length === 0){
      this.pe_assignmentSearchForm.controls['PEId'].patchValue(-1);
  }

  this.pe_assignmentSearchForm.clearValidators();
  this.filter.SearchFilterConditions = [];
  this.filter = this.setFilterCondition(this.filter, this.pe_assignmentSearchForm, 'SourceTypeId', Constants.FILTER_DATATYPE_NUMBER,  Constants.FILTER_OPERATOR_TYPE_EQUAL);
  this.filter = this.setFilterCondition(this.filter, this.pe_assignmentSearchForm, 'PartCategoryId', Constants.FILTER_DATATYPE_NUMBER,  Constants.FILTER_OPERATOR_TYPE_EQUAL);
  this.filter = this.setFilterCondition(this.filter, this.pe_assignmentSearchForm, 'SupplierCode', Constants.FILTER_DATATYPE_STRING,  Constants.FILTER_OPERATOR_TYPE_EQUAL);
//  this.filter = this.setFilterCondition(this.filter, this.pe_assignmentSearchForm, 'SioCodeId', Constants.FILTER_DATATYPE_STRING,  Constants.FILTER_OPERATOR_TYPE_EQUAL);
  this.filter = this.setFilterCondition(this.filter, this.pe_assignmentSearchForm, 'PartNumber', Constants.FILTER_DATATYPE_STRING, Constants.FILTER_OPERATOR_TYPE_LIKE);
}

onEmptyPE(eventObj: any): void {
  this.PEAutoComplete.list = [];
}

getAllCurrentAssignments() {
  const queryAssignmentsForPEDTO: QueryAssignmentsForPEDTO = new QueryAssignmentsForPEDTO();
  queryAssignmentsForPEDTO.SearchFilter = this.filter;
  queryAssignmentsForPEDTO.PEId = this.getPEId();
  queryAssignmentsForPEDTO.SioCodeId = this.getSIOCode();

  this.dataService
      .getPECurrentAssignments(queryAssignmentsForPEDTO)
      .subscribe((response: any) => {
          // this.partInfo = response
          if (response != null) {
              this.peAssignmentsList = response.Data;
              this.gridView = of({
                  data: response.Data,
                  total: response.Total ? response.Total : 0,
              });
              this.getPartSystems();
              this.getSourceTypes();
              this.getSioCodes();
          }

      });
}

deleteMultiplePEAssignment() {
  if(Helper.confirmDeletePEAction()){
    this.dataService
    .deleteMultiplePEAssignment(this.deletePackageEngineerAssignmentDTO)
    .subscribe((response: any) => {
        if (response != null && response.Success) {
            this.toastService.success('Selected assignment(s) deleted');
        }
        else {
          this.toastService.error(
              'PE assignments not deleted'
          );
      }
        this.fillGrid();
    });
  }
  else {
    this.uncheckWhenCancelled();
    this.toastService.info('Delete request cancelled');
    }
}

//TMS-26668 - uncheck when user cancels delete request
uncheckWhenCancelled(){
  this.peAssignmentsList.forEach(item => {
    item.IsSelected = false;
  });
  this.isDeleteButtonClicked = false;
  this.deletePackageEngineerAssignmentDTO.ids = [];
}

checkSearchFormFilter(): boolean {
  return this.pe_assignmentSearchForm.controls['PEId'].value ||
          this.pe_assignmentSearchForm.controls['SourceTypeId'].value ||
          this.pe_assignmentSearchForm.controls['PartCategoryId'].value ||
          this.pe_assignmentSearchForm.controls['SupplierCode'].value ||
    this.pe_assignmentSearchForm.controls['PartNumber'].value ||
          this.pe_assignmentSearchForm.controls['SioCodeId'].value;
}

searchPEAssignment() {
  this.ValidateSearchForm();
  if (this.pe_assignmentSearchForm.valid) {
      // get current assignments
      this.searchClicked = true;
      // this.UpdateFilter();
      this.search();
  }
}

clearFilter() {
  this.pe_assignmentSearchForm.reset();
  this.peAssignmentsList = [];
  this.deletePackageEngineerAssignmentDTO.ids = [];
  this.reassignPackageEngineerDTO.CurrentAssignmentIds = [];
}

getSourceTypes() {
  this.dataService.getParentSourceTypes().subscribe((response: any) => {
      if (response != null && response.Success) {
        this.sourceTypeList = response.Data;
      }
  });
}
getPartSystems() {
  this.dataService.getPartSystems().subscribe((response: any) => {
          if (response != null && response.Success) {
            this.partSystemList = response.Data;
          }
  });
}
getSioCodes() {
  this.dataService.getSioCodes().subscribe((response: any) => {
    if (response != null && response.Success) {
      this.sioCodeList = response.Data;
    }
});
}

ValidateSearchForm() {
  this.formErrors = this.FormService.validateForm(
      <FormGroup>this.pe_assignmentSearchForm,
      this.formErrors
  );
}

getPEId() {
  return this.pe_assignmentSearchForm.controls['PEId'].value;
}
getSourceTypeId() {
  return this.pe_assignmentSearchForm.controls['SourceTypeId'].value;
}
getPartCategoryId() {
  return this.pe_assignmentSearchForm.controls['PartCategoryId'].value;
}
getSupplierCode() {
  return this.pe_assignmentSearchForm.controls['SupplierCode'].value;
}

 //tms-34809 extract siocode ids as a list as tsl-multiselect always returns object
  getSIOCode() {
    var siocode = this.pe_assignmentSearchForm.controls['SioCodeId'].value;
    if (siocode != null) {
      const listofsiocodes = siocode.map(({ Id }) => Id);
      return listofsiocodes;
    }
    return siocode;
  }

onEmptySupplierCode(eventObj: any): void {
//  this.pe_addAssignmentForm.controls['SupplierCode'].patchValue(null);
  this.SupplierAutoComplete.list = [];
  if (this.filter != null && this.filter.SearchFilterConditions != null && this.filter.SearchFilterConditions.findIndex(x => x.Field === 'SupplierCode') >= 0) {
      this.filter.SearchFilterConditions.splice(this.filter.SearchFilterConditions.findIndex(x => x.Field === 'SupplierCode'), 1);
  }
}

refreshToolTipText(code: string) {
  this.supplierAssginmentMessage = Constants[code];
  this.SIOCodeAssginmentMessage = Constants[code];
}

ValidateAddForm() {
  this.formErrors = this.FormService.validateForm(
      <FormGroup>this.pe_assignmentSearchForm,
      this.formErrors
  );
}

  reassignPEInfo() {
    var currentPEAssignments = this.getSelectedPEAssignments();
    const dialogRef = this.matDialog.open(ReassignPeComponent, {
      height: '600px',
      width: '700px',
      data: currentPEAssignments
    });

    dialogRef.afterClosed().subscribe(result => {
      this.fillGrid();
    });
  }
  getSelectedPEAssignments()
  {
    var currentlySelectedRows = [];
    this.peAssignmentsList.forEach(item => {
      if (item.IsSelected) {
        currentlySelectedRows.push(item);
      }
    });
    return currentlySelectedRows;
  }
  //set flag to true/false based on checkbox selection for delete btn
  onRowSelectedChange(dataItem) {
    const isSelected: boolean = dataItem.checked;
    if(dataItem.IsSelected && !this.deletePackageEngineerAssignmentDTO.ids.includes(dataItem.Id)){
      this.deletePackageEngineerAssignmentDTO.ids.push(dataItem.Id);
    }
    if(!dataItem.IsSelected && this.deletePackageEngineerAssignmentDTO.ids.includes(dataItem.Id)){
      const index = this.deletePackageEngineerAssignmentDTO.ids.indexOf(dataItem.Id);
      this.deletePackageEngineerAssignmentDTO.ids.splice(index, 1);
    }
    if(dataItem.IsSelected && !this.reassignPackageEngineerDTO.CurrentAssignmentIds.includes(dataItem.Id)){
      this.reassignPackageEngineerDTO.CurrentAssignmentIds.push(dataItem.Id);
    }
    if(!dataItem.IsSelected && this.reassignPackageEngineerDTO.CurrentAssignmentIds.includes(dataItem.Id)){
      const index = this.reassignPackageEngineerDTO.CurrentAssignmentIds.indexOf(dataItem.Id);
      this.reassignPackageEngineerDTO.CurrentAssignmentIds.splice(index, 1);
    }
    let selectedCount = 0;
    this.peAssignmentsList.forEach(item => {
      if (item.IsSelected) {
        this.checkboxSelected.push(item.Id);
        selectedCount++;
      }
    });
    if ( isSelected)
    {
      if(this.peAssignmentsList.filter(a => a.IsSelected === true).length === this.peAssignmentsList.length)
   {
      this.allItemsCheckBoxSelected = true;
  }
}
else{
  this.allItemsCheckBoxSelected = false;
}
    if (selectedCount > 0) {
      this.isDeleteButtonClicked = true;
    }
    else {
      this.isDeleteButtonClicked = false;
    }
  }

  setAllSelected(isSelected: boolean) {
    this.peAssignmentsList.map(function(part) {
        part.IsSelected = isSelected;
        return part;
    });
}

  createPEAssignment() {
    this.router.navigate(['pe-add-assignment']);
}

  SioCodeChanged(siocode: SioCode[]) {
  }

  //tms-34809 search siocode and return filtered results
  onSioCodeSearch(val) {
    if (!val || val.length <= 3) {
      this.getSioCodes();
      return;
    }
    else {
      this.sioCodeList = this.sioCodeList.filter(item => item.Description.toLowerCase().startsWith(val.toLowerCase()));
    }
  }

}
